<div class="wizard-container">
  <h4>Filtrar pedidos de corderos</h4>
  <div class="step-content">
    <div class="col-md-3 col-6 mb-2">
      <label for="priFech">Desde:</label>
      <input
        id="priFech"
        type="date"
        class="form-control"
        [(ngModel)]="primerafecha"
      />
    </div>
  </div>
  <div class="step-content">
    <div class="col-md-3 col-6 mb-2">
      <label for="ultFech">Hasta:</label>
      <input
        id="ultFech"
        type="date"
        class="form-control"
        [(ngModel)]="ultimafecha"
      />
    </div>
  </div>

  <div class="col-md-2 col-12 d-flex align-items-end mb-2">
    <button class="btn btn-primary w-100" (click)="cargarPedidos()">
      Buscar
    </button>
  </div>

  <div class="col-md-2 col-12 d-flex align-items-end mb-2">
    <button
      class="btn btn-primary w-100"
      (click)="exportarAExcel()"
      [disabled]="!datosTabla || datosTabla.length === 0"
    >
      Exportar a Excel
    </button>
  </div>
</div>

<div class="container mt-3 d-none d-md-block">
  <h4>Pedidos de corderos</h4>

  <table
    class="table table-striped table-bordered"
    *ngIf="datosTabla?.length > 0"
  >
    <thead class="table-light">
      <tr>
        <th>Fecha</th>
        <th>Socio</th>
        <th>Nombre</th>
        <th>Explotación</th>
        <th>Hembras</th>
        <th>Machos</th>
        <th>Total</th>
        <th>Recogida</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let pedido of datosTabla">
        <td>{{ pedido.ttFecha }}</td>
        <td>{{ pedido.ttSocio }}</td>
        <td>{{ pedido.ttNombr }}</td>
        <td>{{ pedido.ttExplo }}</td>
        <td>{{ pedido.ttHembra }}</td>
        <td>{{ pedido.ttMachos }}</td>
        <td>{{ pedido.ttTotcor }}</td>
        <td>
          <span *ngIf="pedido.ttRecoge === 0">SI</span>
          <span *ngIf="pedido.ttRecoge === 1">NO</span>
          <span *ngIf="pedido.ttRecoge === 2">COOP</span>
        </td>
      </tr>
    </tbody>
  </table>
  <div *ngIf="datosTabla?.length === 0" class="alert alert-info">
    No hay pedidos en el rango seleccionado
  </div>
</div>

<!-- Mobile Cards -->
<div class="container mt-3 d-md-none" *ngIf="datosTabla?.length > 0">
  <h4>Pedidos de corderos</h4>
  <div class="row">
    <div class="col-12 mb-3" *ngFor="let pedido of datosTabla">
      <div class="card pedido-card shadow-sm">
        <div class="card-body">
          <p><strong>Fecha:</strong> {{ pedido.ttFecha }}</p>
          <p><strong>Socio:</strong> {{ pedido.ttSocio }}</p>
          <p><strong>Nombre:</strong> {{ pedido.ttNombr }}</p>
          <p><strong>Explotación:</strong> {{ pedido.ttExplo }}</p>
          <p><strong>Hembras:</strong> {{ pedido.ttHembra }}</p>
          <p><strong>Machos:</strong> {{ pedido.ttMachos }}</p>
          <p><strong>Total:</strong> {{ pedido.ttTotcor }}</p>
          <p>
            <strong>Recogida:</strong>
            <span *ngIf="pedido.ttRecoge === 1">SI</span>
            <span *ngIf="pedido.ttRecoge === 0">NO</span>
            <span *ngIf="pedido.ttRecoge === 2">COOP</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container mt-3 d-md-none" *ngIf="datosTabla?.length === 0">
  <div class="alert alert-info">No hay pedidos en el rango seleccionado</div>
</div>
